import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CampaignLayer from "../components/CampaignLayer";

const CampaignPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Campaigns" />

        {/* CampaignLayer */}

        <CampaignLayer />

      </MasterLayout>
    </>
  );
};

export default CampaignPage;

